// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2ilDW","productName":"Table_productName__3coSp"};